import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.bubble.css";
import ImageResize from "quill-image-resize-module-react";
import PropTypes from "prop-types";

Quill.register("modules/imageResize", ImageResize);

class QuillEditor extends Component {
  render() {
    const { theme, placeholder, value, onChange, ...props } = this.props;

    return (
      <ReactQuill
        theme={theme}
        modules={QuillEditor.modules}
        formats={QuillEditor.formats}
        value={value}
        onChange={onChange}
        placeholder={placeholder || ""}
        {...props}
      />
    );
  }
}

/*
 * https://quilljs.com/docs/modules/
 */
QuillEditor.modules = {
  toolbar: [
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import("parchment"),
    modules: ["Resize", "DisplaySize"],
  },
};

/*
 * https://quilljs.com/docs/formats/
 */
QuillEditor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

QuillEditor.propTypes = {
  theme: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default QuillEditor;
